import { addToCart } from '~/js/lib/cart'; // eslint-disable-line

// this file control the get this look popup, add to cart for each block

export default (node) => {
  /**
   * Data + elements
   */

  const showProducts = node.querySelectorAll('[data-show-products]');
  const popupCloseButton = node.querySelector('[data-popup-close]');
  const overlay = document.querySelector('[data-get-this-look-overlay]');
  const template = document.querySelector('[data-template-get-this-look]');
  const mainProducts = node.querySelectorAll(
    '[data-get-this-look-main-products]'
  );
  let closeListener = null;

  /**
   * Functions
   */
  const openPopup = () => {
    const popupProduct = node.querySelector('[data-popup-look-products]');
    template.innerHTML = popupProduct.innerHTML;
    template.classList.add('!translate-y-0');
    template.classList.add('md:look-popup-desktop-open');
    overlay.classList.remove('hidden');
    addAddToCartEventListeners();
    closeListener = template
      .querySelector('[data-popup-close]')
      .addEventListener('click', closePopup);
  };

  const productAddToCart = async (e) => {
    const button = e.currentTarget;
    const variantId = button.dataset.variantId;

    const itemToAdd = [
      {
        id: Number(variantId),
        quantity: 1,
      },
    ];

    await addToCart(itemToAdd);

    document.dispatchEvent(new CustomEvent('cart:open'));
    closePopup();
  };

  const addAddToCartEventListeners = () => {
    const addToCartButtons = template.querySelectorAll(
      '[data-popup-add-to-cart]'
    );

    if (addToCartButtons) {
      addToCartButtons.forEach((button) => {
        button.addEventListener('click', productAddToCart);
      });
    }
  };

  const closePopup = () => {
    template.innerHTML = '';
    template.classList.remove('!translate-y-0');
    template.classList.remove('!-translate-y-1/2');
    template.classList.remove('md:look-popup-desktop-open');
    overlay.classList.add('hidden');
  };

  /**
   * Init
   */
  const init = () => {
    // add listeners for desktop version
    const addToCartButtonsDesktop = node.querySelectorAll(
      '[data-popup-add-to-cart]'
    );
    if (addToCartButtonsDesktop) {
      addToCartButtonsDesktop.forEach((button) => {
        button.addEventListener('click', productAddToCart);
      });
    }
    if (showProducts) {
      showProducts.forEach((showProduct) => {
        showProduct.addEventListener('click', openPopup);
      });
    }

    if (popupCloseButton)
      popupCloseButton.addEventListener('click', closePopup);

    if (overlay) overlay.addEventListener('click', closePopup);

    if (mainProducts) {
      mainProducts.forEach((container) => {
        const products = container.querySelectorAll('[data-popup-add-to-cart]');
        products.forEach((product) => {
          product.addEventListener('click', productAddToCart);
        });
      });
    }
  };

  init();
};
